import {
  Component,
  OnInit,
  ViewChildren,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener,
  OnDestroy,
  Inject,
  DOCUMENT
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';
import {
  SearchObject,
  UserServices,
  MenuSlideEnum,
  OBTAirportDetails,
  ServiceProvider,
  RightPanelMenu,
  LocationTypes,
  FlightSearchType,
  Traveller,
  ChatSearchParameters,
  getServiceTypeFromStartTab,
  getServiceTypeFromPriority,
  isNotOfflineBookingType,
  CabHireEnterpriseSearchInterface,
  TerminalsType,
  RailSearchCriteria
} from '@sabstravtech/obtservices/base';
import {
  EnterpriseBasketService,
  EnterpriseSearchService,
  ModalOpenerService,
  ServiceType,
  StorageService,
  UserService,
  HelperRoutines,
  User,
  WithSubscriptionComponent,
  BannerDisplayTarget,
  CabHireVehicleType,
  SearchDocumentValidationService,
  SearchPaymentValidationService,
  RailSearchJourneyType,
  RailClass,
  ResultAwareService,
  ChatbotService,
  ChatbotSearchDispatcherService
} from '@sabstravtech/obtservices/angular';
import { TravelTypeInfo, TravelTypeInfoType } from '../../../core/interfaces/travel-types';
import { tap, filter, take } from 'rxjs/operators';
import { Observable, firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { faClockRotateLeft, faUser, faStar } from '@fortawesome/free-solid-svg-icons';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';
import { DDAService } from '../../../core/services/dda.service';
import { WCAGFocusHandler } from '../../../core/services/wcag-focus-handler.service';
import { LanguageService } from '../../../core/services/language.service';
import { ThemeService } from '../../../core/services/theme.service';
import { LightningUserFavorurite } from '../../../core/classes/user-favourite.enum';

const now = new Date();
const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(MenuSlideEnum.IN, style({ transform: 'translate3d(-100%, 0, 0)' })),
      state(MenuSlideEnum.OUT, style({ transform: 'translate3d(0, 0, 0)' })),
      state(MenuSlideEnum.FLAT, style({ transform: 'translate3d(0, 33px, 0)' })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ],
  standalone: false
})
export class SearchComponent
  extends WithSubscriptionComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('searchForm') searchForm;
  @ViewChildren('input') trvNpt;
  @ViewChild('main') main: ElementRef;
  @ViewChild('basket') basket: ElementRef;
  @ViewChild('basketExpanderButton') basketExpanderButton: ElementRef;

  get basketCounter(): number {
    return this.basketService.getNumberItemsForBasket();
  }

  ServiceType: typeof ServiceType = ServiceType;
  FlightSearchType: typeof FlightSearchType = FlightSearchType;
  ServiceProvider: typeof ServiceProvider = ServiceProvider;
  travelServices = new FormControl();
  flight_chosen = false;
  rail_chosen = false;
  showMore = true;
  hotel_chosen = false;
  car_chosen = false;
  toolTipClicked = false;
  show_errors = false;
  showRecentSearch = true;
  showMyBaskets = false;
  showFrequentTravellers = false;
  menuOpen = false;
  RightPanelMenu = RightPanelMenu;
  MenuSlideEnum = MenuSlideEnum;
  selectedRightPanelItem: RightPanelMenu = RightPanelMenu.RecentSearches;

  nights: number;
  location: string;
  currentUser: User;
  start_date: NgbDateStruct = {
    year: now.getFullYear(),
    month: now.getMonth() + 1,
    day: now.getDate()
  };
  end_date: NgbDateStruct = {
    year: tomorrow.getFullYear(),
    month: tomorrow.getMonth() + 1,
    day: tomorrow.getDate()
  };
  showTravelerInput = false;
  showTravelerDropdown = false;
  showGuestTravellerForm = false;
  canBookOther = true;
  bookableTravelTypes: TravelTypeInfoType[] = [];
  loadingTravellerProfile = false;
  loadingSSO = false;
  otherTravelTypes = [ServiceType.Lounge, ServiceType.Parking, ServiceType.Cab];
  userServices$: Observable<UserServices>;
  passportErrors: string[] = [];
  railcardErrors: string[] = [];
  hotelsearchRequested = false;
  hasTrainline = false;
  displayTarget = BannerDisplayTarget.SearchForm;
  displayItinerary = false;
  userIsAgent = false;
  serviceType: ServiceType;
  showUnavailableServices = false;
  showPaymentWarning = false;
  hasNoStoredCard = false;
  invokedUser: Traveller = null;
  paymentRestrictions: { [key in ServiceType]?: boolean } = {};
  faClockRotateLeft = faClockRotateLeft;
  faUser = faUser;
  faStar = faStar;
  public innerWidth: any;

  constructor(
    public userService: UserService,
    public searchService: EnterpriseSearchService,
    public basketService: EnterpriseBasketService,
    public modalService: ModalOpenerService,
    public ddaService: DDAService,
    private storageService: StorageService,
    private title: Title,
    public translateService: TranslateService,
    private helpers: HelperRoutines,
    private wcagFocusHandlerService: WCAGFocusHandler,
    private languageService: LanguageService,
    public themeService: ThemeService,
    private documentValidationService: SearchDocumentValidationService,
    private paymentValidationService: SearchPaymentValidationService,
    @Inject(DOCUMENT) private document: any,
    private chatbotService: ChatbotService,
    private resultAwareService: ResultAwareService,
    private chatbotSearchDispatcher: ChatbotSearchDispatcherService
  ) {
    super();
  }

  @HostListener('document:click', ['$event.target'])
  public onClick() {
    if (window.innerWidth > 1600) {
      this.basketService.menuState = MenuSlideEnum.OUT;
    }
    if (this.toolTipClicked === true) {
    } else if (this.basketService.menuState === MenuSlideEnum.IN) {
      this.toolTipClicked = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.onLoad();
  }

  ngOnInit() {
    this.userIsAgent = this.userService.userIsAgent();

    const ssoQuery = window.location.href.split('?')[1]?.split('#')[0];
    if (ssoQuery && this.searchService.ssoCall) {
      this.loadingSSO = true;
    }

    this.subscribe(this.userService.fullUserDetails.allDetails, (fullUser: User) => {
      if (fullUser) {
        this.currentUser = fullUser;

        this.updateShowUnavailableServices();
        this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();

        setTimeout(() => {
          this.handleSSOCall(ssoQuery);
        }, 2000);

        this.handleLanguageSelection(fullUser);

        if (this.searchService.searches[ServiceType.Hotel]) {
          this.searchService.searches[ServiceType.Hotel].backToType = null;
        }

        if (!this.userService.bobo) {
          this.getUserPassports(fullUser.id);
        }
      }
    });

    this.searchService.resetSearchPriorities();
    this.title.setTitle(
      this.translateService.instant(
        `New Search ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
      )
    );
    this.getUserServices();
    this.basketService.reset();

    this.subscribe(this.basketService.basketChangeEmitter, (id: string) => {
      this.basketService.getRequiresReasonService().currentBasketid = id;
      this.basketService.getRequiresOverrideReasonService().currentBasketid = id;
    });

    this.travelServices.setValue([]);
    this.onLoad();

    this.subscribe(this.userService.fullUserDetails.userServices, (services: UserServices) => {
      this.invokedUser = this.userService.bobo;
      if (services) {
        if (this.invokedUser) {
          this.checkUserPaymentWarnings(services);
        } else {
          this.showPaymentWarning = false;
          Object.keys(services).forEach((key) => {
            this.paymentRestrictions[key] = false;
          });
        }
        this.bookableTravelTypes = TravelTypeInfo.filter((info) => services[info.type]);
      }
    });

    this.searchService.determineHighestSearchPriority();
    const found = this.searchService.search_objects
      ? Object.values(this.searchService.search_objects).find((item: SearchObject) => {
          return item.autosearch && this.searchService.highest_search_priority === item.priority;
        })
      : null;

    if (found) {
      this.fetchSearchAll();
    }

    this.subscribe(this.wcagFocusHandlerService.skipToBasketClicked, () => {
      if (window.innerWidth <= 1600) {
        this.basketExpanderButton.nativeElement.focus();
      } else {
        this.document.getElementById('my-baskets-tab').focus();
      }
    });

    this.subscribe(this.userService.newInvokedUser, (user: Traveller) => {
      if (user && !user.guest) {
        this.getUserPassports(user.id);
      } else if (!user && this.currentUser) {
        this.getUserPassports(this.currentUser.id);
      }
    });

    this.searchService.simultaneousHotelSearchRequested = false;

    this.subscribe(this.chatbotService.fillSearchForm$, ({ parameters, autoSearch }) => {
      // Travel types registered with ChatbotSearchDispatcherService (rail,
      // flight, hotel, eurostar) run from any page via the dispatcher. Skip
      // those here to avoid double-handling once the dispatcher is active.
      if (this.chatbotSearchDispatcher.handles(parameters?.travelType)) {
        return;
      }
      this.fillFromChatbot(parameters, autoSearch);
    });
  }

  ngOnDestroy(): void {
    this.basketService.getRequiresReasonService().currentBasketid = null;
    this.basketService.getRequiresOverrideReasonService().currentBasketid = null;
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    this.ddaService.main = this.main;
    this.ddaService.basket = this.basket;
    this.subscribe(this.searchService.isGutMeeting, (isGutMeeting: boolean) => {
      if (isGutMeeting) {
        this.selectedRightPanelItem = this.displayItinerary
          ? RightPanelMenu.MyItineraries
          : RightPanelMenu.MyBaskets;
        this.openRightPanelMenu(this.selectedRightPanelItem, false);
      } else {
        this.selectedRightPanelItem =
          (
            this.userService.getUserFavoriteObject(LightningUserFavorurite.startTab) as {
              sideMenu: RightPanelMenu;
            }
          )?.sideMenu || RightPanelMenu.RecentSearches;
        this.openRightPanelMenu(this.selectedRightPanelItem, false);
      }
    });
  }

  private handleSSOCall(ssoQuery: string): void {
    if (ssoQuery && this.searchService.ssoCall) {
      ssoQuery = ssoQuery.replace(/%3A/g, '');
      const splitQuery = ssoQuery.split('&');
      const ssoObject = splitQuery.reduce((acc, param) => {
        const splitParam = param.split('=');
        acc[splitParam[0]] = splitParam[1];
        return acc;
      }, {});
      this.searchService.ssoCall = false;

      if (ssoObject['originAirport'] && this.searchService.searches[ServiceType.Flight]) {
        this.searchService.makePortalFlightCall(ssoObject);
      } else if (ssoObject['originStation'] && this.searchService.searches[ServiceType.Rail]) {
        const checkSearchObjects = () => {
          if (this.searchService.search_objects) {
            this.searchService.makePortalRailCall(ssoObject);
          } else {
            setTimeout(checkSearchObjects, 100);
          }
        };
        checkSearchObjects();
      } else {
        console.error('+++ UNKNOWN SSO CALL TYPE OR SEARCH NOT LOADED +++');
        this.loadingSSO = false;
      }
    }
  }

  private handleLanguageSelection(fullUser: User): void {
    const selectedLanguage = fullUser?.selectedLanguage;
    const isSupprtAgent = this.userService.userIsSupportAgent();
    if (selectedLanguage && !isSupprtAgent) {
      const availableLanguages = fullUser.availableLanguages.map((lang) => lang.isoCode);
      this.languageService.changeLanguageFromUserDetails(
        selectedLanguage.name,
        selectedLanguage.isoCode,
        availableLanguages
      );
    }
  }

  getUserServices(): void {
    this.userServices$ = this.userService.fullUserDetails.userServices.pipe(
      tap((services: UserServices) => {
        this.invokedUser = this.userService.bobo;
        if (services) {
          this.setDefaultFilter(services);
          if (this.invokedUser) {
            this.checkUserPaymentWarnings(services);
          } else {
            this.showPaymentWarning = false;
            Object.keys(services).forEach((key) => {
              this.paymentRestrictions[key] = false;
            });
          }
          this.bookableTravelTypes = TravelTypeInfo.filter((info) => services[info.type]);
        }
      })
    );
  }

  setRightPanelItem(showRightPanelMenu: boolean) {
    if (showRightPanelMenu && this.selectedRightPanelItem !== RightPanelMenu.FrequentTravellers) {
      const previousOption: RightPanelMenu = this.selectedRightPanelItem;
      this.selectedRightPanelItem = RightPanelMenu.FrequentTravellers;
      this.openRightPanelMenu(this.selectedRightPanelItem);
      setTimeout(() => {
        this.selectedRightPanelItem = previousOption;
        this.openRightPanelMenu(this.selectedRightPanelItem);
      }, 3000);
    }
  }

  noFilterSelected(): boolean {
    if (!this.searchService.search_objects) {
      return true;
    }
    return (
      !this.searchService.search_objects[ServiceType.Lounge]?.chosen &&
      !this.searchService.search_objects[ServiceType.Parking]?.chosen &&
      !this.searchService.search_objects[ServiceType.Eurostar]?.chosen &&
      !this.searchService.search_objects[ServiceType.Cab]?.chosen &&
      !this.searchService.search_objects[ServiceType.Flight]?.chosen &&
      !this.searchService.search_objects[ServiceType.Rail]?.chosen &&
      !this.searchService.search_objects[ServiceType.InternationalRail]?.chosen &&
      !this.searchService.search_objects[ServiceType.Hotel]?.chosen &&
      !this.searchService.search_objects[ServiceType.Car]?.chosen
    );
  }

  setDefaultFilter(services: UserServices) {
    this.searchService.simultaneousSearchesCheck(false);
    const isNoFilterSelected = this.noFilterSelected();
    const servicesKeys = services ? Object.keys(services) : [];

    this.subscribe(this.userService.fullUserDetails.userConfigs, () => {
      this.updateShowUnavailableServices();
      const startTab = this.userService.getUserFavoriteValue(LightningUserFavorurite.startTab);
      const isStartTabIncluded =
        startTab && servicesKeys.length ? servicesKeys.includes(ServiceType[startTab]) : false;
      if (isNoFilterSelected && isStartTabIncluded && startTab) {
        this.selectStartTab(startTab);
      }
    });

    if (services && services[ServiceType.Rail] && services[ServiceType.Rail].length) {
      const trainline = services[ServiceType.Rail].filter(
        (service) => service.name === ServiceProvider.Trainline
      );
      this.hasTrainline = trainline.length > 0;
    }
  }

  toggleOptionAttempt(choice: ServiceType): void {
    const searchObj = this.searchService.search_objects[choice];
    if (
      searchObj.type === ServiceType.Flight &&
      searchObj.chosen === false &&
      this.searchService.hasSimpleGuests()
    ) {
      this.modalService
        .open(LightningModalTypes.ModalGuestTravellerComponent, {}, {})
        .then((success) => {
          if (success) {
            this.toggleOption(choice);
          }
        });
      return;
    }
    this.toggleOption(choice);
  }

  toggleRailHotelCombo(): void {
    this.searchService.searches[ServiceType.Flight].isFlightHotelComboSearch = false;
    if (this.searchService.searches[ServiceType.Rail].isRailHotelComboSearch) {
      if (this.searchService.search_objects[ServiceType.Rail]?.chosen) {
        this.toggleOption(ServiceType.Rail);
      }
      if (this.searchService.search_objects[ServiceType.Hotel]?.chosen) {
        this.toggleOption(ServiceType.Hotel);
      }
      this.searchService.searches[ServiceType.Rail].isRailHotelComboSearch = false;
      return;
    }

    if (this.searchService.search_objects[ServiceType.Flight]?.chosen) {
      this.toggleOption(ServiceType.Flight);
    }
    if (!this.searchService.search_objects[ServiceType.Rail]?.chosen) {
      this.toggleOption(ServiceType.Rail);
    }
    if (!this.searchService.search_objects[ServiceType.Hotel]?.chosen) {
      this.toggleOption(ServiceType.Hotel);
    }
    this.searchService.searches[ServiceType.Rail].isRailHotelComboSearch = true;
  }

  toggleFlightHotelCombo(): void {
    this.searchService.searches[ServiceType.Rail].isRailHotelComboSearch = false;
    if (this.searchService.searches[ServiceType.Flight].isFlightHotelComboSearch) {
      if (this.searchService.search_objects[ServiceType.Flight]?.chosen) {
        this.toggleOption(ServiceType.Flight);
      }
      if (this.searchService.search_objects[ServiceType.Hotel]?.chosen) {
        this.toggleOption(ServiceType.Hotel);
      }
      this.searchService.searches[ServiceType.Flight].isFlightHotelComboSearch = false;
      return;
    }

    if (this.searchService.search_objects[ServiceType.Rail]?.chosen) {
      this.toggleOption(ServiceType.Rail);
    }
    if (!this.searchService.search_objects[ServiceType.Flight]?.chosen) {
      this.toggleOption(ServiceType.Flight);
    }
    if (!this.searchService.search_objects[ServiceType.Hotel]?.chosen) {
      this.toggleOption(ServiceType.Hotel);
    }
    this.searchService.searches[ServiceType.Flight].isFlightHotelComboSearch = true;
  }

  toggleOption(choice: ServiceType): void {
    this.searchService.isFavoritesSelected = false;
    this.searchService.search_objects[choice].chosen =
      !this.searchService.search_objects[choice].chosen;
    this.searchService.search_objects[choice].originalChosen =
      this.searchService.search_objects[choice].chosen;
    this.storageService.setSessionItem('search_params', this.searchService.search_objects);
    this.searchService.determineHighestSearchPriority();
    this.serviceType = this.getServiceType();
  }

  isEmpty(variable: string[]): boolean {
    return _.isEmpty(variable);
  }

  setOption(choice: string, value: boolean): void {
    this.searchService.search_objects[choice].chosen = value;
    this.searchService.search_objects[choice].originalChosen = value;
    this.searchService.search_objects[choice].autosearch = false;
    this.searchService.determineHighestSearchPriority();
    this.serviceType = this.getServiceType();
  }

  selectedOptions(): ServiceType[] {
    return this.searchService.getSelectedOptions();
  }

  async fetchSearchAll(): Promise<void> {
    this.searchService.isFavouriteSearch = false;
    setTimeout(async () => {
      if (!this.searchService.validateForms() && this.searchForm) {
        this.show_errors = true;
        const context = this;
        setTimeout(function () {
          window.scrollTo({ behavior: 'smooth', top: 0 });
          context.searchForm.nativeElement.blur();
          if (
            document.body.classList.contains('user-is-tabbing') &&
            document.getElementById('error-message-list')
          ) {
            document.getElementById('error-alert').style.display = 'block';
            document.getElementById('error-alert').focus();
            setTimeout(function () {
              document.getElementById('error-alert').style.display = 'none';
            }, 1000);
          }
        }, 0);
        return;
      } else {
        await this.searchService.simultaneousSearchesCheck(true);
        this.show_errors = false;
      }

      if (this.searchService.searches[ServiceType.InternationalRail].offlineRequest) {
        this.searchService.startSearches('search');
      } else {
        if (
          this.searchService.search_objects[ServiceType.Cab].chosen &&
          this.userService.userHasServiceProvider(ServiceType.Cab, ServiceProvider.CMAC) &&
          (this.searchService.searches[ServiceType.Cab].vehicleType ===
            CabHireVehicleType.DdaCoach ||
            this.searchService.searches[ServiceType.Cab].vehicleType === CabHireVehicleType.DdaCar)
        ) {
          const wheelChairRequirements = await this.modalService.open(
            LightningModalTypes.TaxiWheelchairModalComponent,
            { centered: true, backdrop: 'static' }
          );
          this.searchService.searches[ServiceType.Cab].specialRequirements = wheelChairRequirements;
        }

        if (
          this.searchService.searches[ServiceType.Hotel].checkForHotelReminder(
            this.hotelsearchRequested
          ) &&
          this.searchService.search_objects.HOTEL.enabled
        ) {
          this.searchService.search_objects[ServiceType.Hotel].chosen = true;
          return this.searchService.startSearches();
        } else {
          return this.searchService.startSearches();
        }
      }
    }, 500);
  }

  getModalHotelNightsParams(outBoundDate: moment.Moment, inboundDate: moment.Moment): number {
    const startOfOutBoundDate = outBoundDate.clone().startOf('day');
    const startInboundDate = inboundDate.clone().startOf('day');
    return Math.abs(startOfOutBoundDate.diff(startInboundDate, 'days'));
  }

  getModalHotelLocationParamFlightEurostar(type: string): string {
    return (this.searchService.searches[type].arriveLocation as OBTAirportDetails)?.destination;
  }

  closeValidationErrors(): void {
    this.searchService.show_errors = false;
    this.searchService.traveller_error = false;
  }

  startAgain(): void {
    this.searchService.reset();
  }

  toggleMenu(): void {
    this.basketService.toggleMenu();
    this.toolTipClicked = false;
  }

  setLoadingTravellerProfile(loading: boolean): void {
    this.loadingTravellerProfile = loading;
  }

  onPanelClick(e) {
    e.stopPropagation();
  }

  onLoad() {
    this.basketService.menuState = MenuSlideEnum.OUT;
  }

  selectStartTab(startTab: string) {
    const serviceType = getServiceTypeFromStartTab(startTab);
    if (serviceType) {
      this.setOption(serviceType, true);
    }
  }

  openRightPanelMenu(selectedItem: RightPanelMenu, setFocus = true) {
    this.selectedRightPanelItem = selectedItem;
    this.menuOpen = false;
    this.showMyBaskets = false;
    this.showRecentSearch = false;
    this.showFrequentTravellers = false;

    switch (selectedItem) {
      case RightPanelMenu.RecentSearches:
        this.showRecentSearch = true;
        break;
      case RightPanelMenu.MyBaskets:
      case RightPanelMenu.MyItineraries:
        this.showMyBaskets = true;
        break;
      case RightPanelMenu.FrequentTravellers:
        this.showFrequentTravellers = true;
        break;
      default:
        this.showRecentSearch = true;
    }
  }

  becomingUser(): boolean {
    return false;
  }

  getUserPassports(userId: string) {
    this.passportErrors = [];
    this.railcardErrors = [];

    this.subscribe(this.documentValidationService.validateUserDocuments(userId), (result) => {
      this.passportErrors = result.passportErrors;
      this.railcardErrors = result.railcardErrors;
    });
  }

  getCarHireLocation(): string {
    const carSearch = this.searchService.searches[ServiceType.Car];
    switch (carSearch.locationType) {
      case LocationTypes.Airport:
        return carSearch.dropoff_location?.destination;
      case LocationTypes.City:
        return carSearch.cityDropoff?.name;
      case LocationTypes.Postcode:
        return carSearch.postcodeDropoff?.cityName;
    }
  }

  toggleHotelSearchRequested(requested: boolean) {
    this.hotelsearchRequested = requested;
    this.searchService.simultaneousHotelSearchRequested = requested;
  }

  getServiceType(): ServiceType {
    return getServiceTypeFromPriority(
      this.searchService.search_objects,
      this.searchService.highest_search_priority
    );
  }

  get selectedServiceIsNotOfflineBooking() {
    return isNotOfflineBookingType(this.serviceType);
  }

  private async fillFromChatbot(
    parameters: ChatSearchParameters,
    autoSearch: boolean
  ): Promise<void> {
    const serviceType =
      parameters.travelType === 'flight'
        ? ServiceType.Flight
        : parameters.travelType === 'hotel'
          ? ServiceType.Hotel
          : parameters.travelType === 'eurostar'
            ? ServiceType.Eurostar
            : parameters.travelType === 'taxi'
              ? ServiceType.Cab
              : parameters.travelType === 'lounge'
                ? ServiceType.Lounge
                : ServiceType.Rail;

    this.searchService.resetSearchChosenObjects();
    this.searchService.resetSearchPriorities();

    this.searchService.search_objects[serviceType].chosen = true;
    this.searchService.search_objects[serviceType].originalChosen = true;
    this.searchService.determineHighestSearchPriority();
    this.serviceType = this.getServiceType();

    if (this.searchService.travellerInformation.value.length === 0) {
      const selfTraveller = this.userService.createSelfTraveller();
      if (selfTraveller) {
        this.searchService.addTraveller(selfTraveller);
      }
    }

    const departDate = moment(parameters.departureDate);
    const departNgbDate = {
      year: departDate.year(),
      month: departDate.month() + 1,
      day: departDate.date()
    };

    switch (serviceType) {
      case ServiceType.Flight:
        await this.fillFlightFromChatbot(parameters, departNgbDate);
        break;
      case ServiceType.Rail:
        await this.fillRailFromChatbot(parameters, departNgbDate);
        break;
    }

    if (autoSearch) {
      if (parameters.travelType === 'rail') {
        const railSearch = this.searchService.searches[ServiceType.Rail];
        setTimeout(async () => {
          await railSearch.startSearch();
          const railResults = railSearch.results.value;
          if (railResults?.[0]) {
            this.resultAwareService.captureRailResults(railResults[0]);
          }
        }, 500);
      } else {
        setTimeout(() => {
          this.fetchSearchAll();
        }, 500);
      }
    }
  }

  private async fillFlightFromChatbot(
    parameters: ChatSearchParameters,
    departNgbDate: NgbDateStruct
  ): Promise<void> {
    const flightParams = this.searchService.searches[ServiceType.Flight];

    flightParams.departDate = departNgbDate;
    if (parameters.departureTime) {
      flightParams.departTime = this.normalizeTime(parameters.departureTime);
    }
    if (parameters.returnDate) {
      const returnDate = moment(parameters.returnDate);
      flightParams.returnDate = {
        year: returnDate.year(),
        month: returnDate.month() + 1,
        day: returnDate.date()
      };
      flightParams.chosenSearchType = FlightSearchType.return;
      if (parameters.returnTime) {
        flightParams.arriveTime = this.normalizeTime(parameters.returnTime);
      }
    } else {
      flightParams.chosenSearchType = FlightSearchType.oneWay;
    }

    flightParams.departLocation = await this.resolveAirport(
      parameters.departureCode,
      parameters.departure
    );
    flightParams.arriveLocation = await this.resolveAirport(
      parameters.arrivalCode,
      parameters.arrival
    );
  }

  private async resolveGeoLocation(
    searchTerm: string,
    taxiParams: CabHireEnterpriseSearchInterface
  ): Promise<{ result: any; address: any } | null> {
    if (!searchTerm) return null;
    try {
      const results = await firstValueFrom(this.searchService.getGeoLocations(searchTerm));
      if (results?.length) {
        const term = searchTerm.toLowerCase();
        let location = results[0];
        if (term.includes('airport')) {
          location = results.find((r) => r.type === LocationTypes.Airport) ?? results[0];
        } else if (term.includes('station') || term.includes('rail')) {
          location = results.find((r) => r.type === LocationTypes.TrainStation) ?? results[0];
        }
        const address = taxiParams.getAddress(location);
        if (location.type === LocationTypes.Airport && !address?.Town) {
          address.Town = location.name;
        }
        return { result: location, address };
      }
    } catch {
      /* no results */
    }
    return null;
  }

  private static matchCabTerminal(aiTerminal: string, terminals: TerminalsType[]): string | null {
    const terminal = aiTerminal.toLowerCase().trim();
    if (!terminal || terminal.includes('any') || terminal.includes('main')) return null;
    const byValue = terminals.find((t) => t.value.toLowerCase() === terminal);
    if (byValue) return byValue.key;
    const byKey = terminals.find(
      (t) => t.key.toLowerCase().includes(terminal) || terminal.includes(t.value.toLowerCase())
    );
    return byKey ? byKey.key : null;
  }

  private async fillRailFromChatbot(
    parameters: ChatSearchParameters,
    departNgbDate: NgbDateStruct
  ): Promise<void> {
    const railParams = this.searchService.searches[ServiceType.Rail];

    railParams.changeLocation(parameters.isEuRail ? 'EU' : 'UK');

    railParams.outbound_date = departNgbDate;
    if (parameters.departureTime) {
      railParams.outbound_time = this.normalizeTime(parameters.departureTime);
    }
    if (parameters.returnDate) {
      const returnDate = moment(parameters.returnDate);
      railParams.return_date = {
        year: returnDate.year(),
        month: returnDate.month() + 1,
        day: returnDate.date()
      };
      railParams.chosenSearchType = RailSearchJourneyType.ReturnJourney;
      if (parameters.returnTime) {
        railParams.return_time = this.normalizeTime(parameters.returnTime);
      }
    } else {
      railParams.chosenSearchType = RailSearchJourneyType.SingleJourney;
    }

    // Optional: rail class
    if (parameters.railClass) {
      railParams.chosenSearchClass = RailClass[parameters.railClass] ?? RailClass.All;
    }

    // Optional: time criteria (depart after / arrive before)
    if (parameters.outboundTimeCriteria) {
      railParams.outboundCriteria =
        parameters.outboundTimeCriteria === 'Arrive'
          ? RailSearchCriteria.Arrive
          : RailSearchCriteria.Depart;
    }
    if (parameters.returnTimeCriteria) {
      railParams.returnCriteria =
        parameters.returnTimeCriteria === 'Arrive'
          ? RailSearchCriteria.Arrive
          : RailSearchCriteria.Depart;
    }

    // Airport express: explicitly set or reset to avoid stale state from previous searches
    if (parameters.isAirportExpress) {
      railParams.isAirportExpress = true;
      if (parameters.airportExpressRoute) {
        railParams.airportExpressStation = parameters.airportExpressRoute;
      }
    } else {
      railParams.isAirportExpress = false;
      railParams.airportExpressStation = null;
    }

    // Optional: children
    if (parameters.children) {
      railParams.noOfChildren = parameters.children;
    }

    // Resolve origin + destination stations
    const resolvePromises: Promise<any>[] = [
      this.resolveRailStation(parameters.departureCode, parameters.departure),
      this.resolveRailStation(parameters.arrivalCode, parameters.arrival)
    ];
    // Optional: via station
    if (parameters.viaStation || parameters.viaCode) {
      resolvePromises.push(
        this.resolveRailStation(parameters.viaCode, parameters.viaStation || '')
      );
    }

    const [from, to, viaResolved] = await Promise.all(resolvePromises);
    if (from) {
      railParams.travellingFrom = from;
    }
    if (to) {
      railParams.travellingTo = to;
    }
    if (this.isEuRailJourney(from, to)) {
      railParams.ukRail = false;
    }
    if (viaResolved) {
      railParams.via = true;
      railParams.viaLocation = viaResolved;
    }

    // Re-apply journey type after station resolution. Setting travellingFrom/To
    // triggers _isValid() → validateAndPrepare() which can reset chosenSearchType
    // from session storage.
    if (parameters.returnDate) {
      railParams.chosenSearchType = RailSearchJourneyType.ReturnJourney;
    }

    if (parameters.railcards?.length) {
      const availableCards = await firstValueFrom(this.searchService.getRailCards('GB'));
      const matched = parameters.railcards
        .map((code) => {
          const upper = code.toUpperCase();
          return availableCards.find(
            (c) => c.code.toUpperCase() === upper || c.name.toUpperCase().includes(upper)
          );
        })
        .filter((c): c is NonNullable<typeof c> => !!c);
      if (matched.length) {
        railParams.railCards = matched;
        // Prevent preselectRailcardsForTravellers from overriding the chatbot selection
        railParams.applyRailcards = true;
      }
    }
  }

  private updateShowUnavailableServices(): void {
    if (!this.currentUser) {
      return;
    }
    const enableNonconfiguredProductsUIConfig = this.userService.getUserFavoriteObject(
      LightningUserFavorurite.enableNonconfiguredProducts
    ) as {
      enableNonconfiguredProducts: boolean;
    };
    this.showUnavailableServices = enableNonconfiguredProductsUIConfig
      ? enableNonconfiguredProductsUIConfig.enableNonconfiguredProducts
      : false;
  }

  /** Returns true if either station is outside GB, meaning the journey needs Trainline EU routing. */
  private isEuRailJourney(from: any, to: any): boolean {
    return [from, to].some((station) => {
      const cc = station?.railstation?.locationDetails?.countryCode;
      return cc && cc !== 'GB';
    });
  }

  /** Convert time strings like "7:00", "7am", "14:30" to dropdown value format "0700", "0700", "1430" */
  private normalizeTime(time: string): string {
    const parsed = moment(time, ['H:mm', 'HH:mm', 'ha', 'h:mma', 'h a', 'h:mm a']);
    if (parsed.isValid()) {
      return parsed.format('HHmm');
    }
    return time.replace(':', '');
  }

  /** Resolve an airport by IATA code first, then by name. Returns null if neither works. */
  private async resolveAirport(code: string | undefined, name: string): Promise<any> {
    // Try code first (more reliable match)
    if (code?.length >= 3) {
      try {
        const byCode = await firstValueFrom(this.searchService.getAirportsList(code, null));
        if (byCode?.length > 0) {
          return byCode.find((a: any) => a.gateway === code) || byCode[0];
        }
      } catch {
        /* fall through to name search */
      }
    }
    // Fall back to name
    if (name?.length > 2) {
      try {
        const byName = await firstValueFrom(this.searchService.getAirportsList(name, null));
        if (byName?.length > 0) {
          return byName[0];
        }
      } catch {
        /* no results */
      }
    }
    return null;
  }

  private async resolveAirportByCode(iata: string): Promise<any> {
    try {
      const results = await firstValueFrom(this.searchService.getAirportsList(iata, null));
      return results?.find((a: any) => a.gateway === iata) ?? results?.[0] ?? null;
    } catch {
      return null;
    }
  }

  /**
   * For rail searches, prefer a hub/group station (e.g. "Manchester (All)") over
   * individual stations, then a non-airport station over airport stations.
   */
  private preferRailStation<T extends { name?: string }>(stations: T[]): T {
    const hub = stations.find((s) => s.name && /\bhub\b/i.test(s.name));
    if (hub) {
      return hub;
    }
    const nonAirport = stations.find((s) => s.name && !s.name.toLowerCase().includes('airport'));
    return nonAirport || stations[0];
  }

  /**
   * Resolve a rail station by CRS code first, then fall back to name. The
   * underlying typeahead API matches the name as a substring, so passing
   * the bare name ("Chester") can pick "Manchester Oxford Road"; the code
   * disambiguates exactly. Mirrors `resolveAirport` for the flight path.
   */
  private async resolveRailStation(code: string | undefined, name: string): Promise<any> {
    if (!name && !code) {
      return null;
    }

    // Try the station code first (most reliable, e.g. "MAN", "LDS")
    if (code) {
      const byCode = await this.lookupRailStations(code);
      if (byCode?.length) {
        const exact = byCode.find(
          (s: any) => s?.railstation?.stationCode === code || s?.stationCode === code
        );
        if (exact) {
          return exact;
        }
        const preferred = this.preferRailStation(byCode);
        if (preferred) {
          return preferred;
        }
      }
    }

    if (!name) {
      return null;
    }

    // The bot may send names like "Manchester (all stations)" or "London Euston (LDN)".
    // The station search API doesn't match parentheticals, so try cleaned variants in order.
    const candidates = this.buildRailStationNameCandidates(name);
    for (const candidate of candidates) {
      const stations = await this.lookupRailStations(candidate);
      if (stations?.length) {
        if (code) {
          const byCode = stations.find(
            (s: any) => s?.railstation?.stationCode === code || s?.stationCode === code
          );
          if (byCode) {
            return byCode;
          }
        }
        const preferred = this.preferRailStation(stations);
        if (preferred) {
          return preferred;
        }
      }
    }
    return null;
  }

  private async lookupRailStations(query: string): Promise<any[] | null> {
    try {
      const stations: any[] = await firstValueFrom(this.searchService.getStationLocations(query));
      return stations ?? null;
    } catch {
      return null;
    }
  }

  /**
   * Generate progressively-cleaner name variants for rail station lookup.
   * e.g. "Manchester (all stations)" → ["Manchester (all stations)", "Manchester", "Manchester all stations"]
   */
  private buildRailStationNameCandidates(name: string): string[] {
    const variants = new Set<string>();
    const trimmed = name.trim();
    if (trimmed) {
      variants.add(trimmed);
    }

    // Strip parenthetical e.g. "Manchester (all stations)" → "Manchester"
    const withoutParens = trimmed
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (withoutParens) {
      variants.add(withoutParens);
    }

    // Use just the first word as a last resort (e.g. "London Euston" → "London").
    // Require >2 chars to avoid noisy 1–2 letter prefixes like "St" matching the wrong stations.
    const MIN_FALLBACK_WORD_LENGTH = 3;
    const firstWord = withoutParens.split(/\s+/)[0];
    if (firstWord && firstWord.length >= MIN_FALLBACK_WORD_LENGTH) {
      variants.add(firstWord);
    }

    return Array.from(variants);
  }

  private checkUserPaymentWarnings(services: UserServices): void {
    this.subscribe(this.paymentValidationService.validatePaymentMethods(services), (result) => {
      this.hasNoStoredCard = result.hasNoStoredCard;
      this.showPaymentWarning = result.showPaymentWarning;
      this.paymentRestrictions = result.paymentRestrictions;

      if (result.allServicesAreApexxOnly) {
        this.modalService
          .open(
            LightningModalTypes.InfoModalComponent,
            { forceOpen: true, centered: true },
            {
              info: this.translateService.instant(
                'The traveller has not stored their Individual Credit Card as payment method in Lightning. Please ask the user to log into Lightning and add their credit card.'
              ),
              buttonText: this.translateService.instant('Ok')
            }
          )
          .then((modalResult) => {
            if (modalResult) {
              this.userService.setBobo(null);
              this.searchService.removeAllTravellers();
            }
          });
      }
    });
  }
}
